import {SOPostAttachment} from '../../core/attachment/so-post-attachment';
import {AttachmentCore} from './attachment.core';
import {SOGetAttachment} from '../../core/attachment/so-get-attachment';
import {FormField, SelectionOption} from 'lionheartland';
import {postAttachmentFormFieldOptions} from './post-attachment-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {MediaCore} from '../media/media.core';
import {SOGetMedia} from '../../core/media/so-get-media';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostAttachment extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postAttachmentFormFieldOptions);

  RequestClass = SOPostAttachment

  constructor(
    public entityCore: AttachmentCore
  ) {
    super();
    if (postAttachmentFormFieldOptions.media) {
      postAttachmentFormFieldOptions.media.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier(
        'media',
        SOGetMedia,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}